import { keepPreviousData, useQuery } from '@tanstack/react-query'
import { useState } from 'react'
import { useDebounce } from 'react-use'

import { type TypeaheadDynamicModeType } from '@/defs/input'
import { searchTypeahead } from '@/utils/typeaheadUtil'

const EMPTY: never[] = []
const MIN_CHARACTERS = 3

export const useTypeaheadDynamic = (mode: TypeaheadDynamicModeType = 'all') => {
  const [search, setSearch] = useState('')
  const [searchDebounced, setSearchDebounced] = useState('')

  useDebounce(() => setSearchDebounced(search.trim()), 500, [search])

  const isSearchable = search.trim().length >= MIN_CHARACTERS

  const { data = EMPTY, isFetching } = useQuery({
    enabled: searchDebounced.length >= MIN_CHARACTERS,
    placeholderData: keepPreviousData,
    queryFn: ({ signal }) => searchTypeahead({ mode, search: searchDebounced, signal }),
    queryKey: ['typeahead', mode, searchDebounced],
  })

  const loading = isSearchable && (search.trim() !== searchDebounced || isFetching)
  const results = isSearchable ? data : EMPTY

  return { loading, results, search, setSearch }
}
